import { Dropdown } from 'primeng/dropdown';
import { Select } from 'primeng/select';

for (const component of [Dropdown, Select]) {
  Object.defineProperty(component.prototype, 'isVisibleClearIcon', {
    configurable: true,
    get(this: any) {
      const value = this.modelValue();
      return value != null && value !== '' && this.showClear && !this.disabled;
    }
  });
}
